import { useCallback, useContext } from 'react';

import { ApplicationCycleContext } from '@/Contexts/ApplicationCycleContext';
import { TokenContext } from '@/Contexts/TokenContext';
import { useCustomFetch } from '@/hooks/useCustomFetch';
import { ApplicationCycle, ApplicationCycleSelectOption } from '@/models/ApplicationCycle';
import { baseUrl } from '@/utils/constants';

export default function useApplicationCycle() {
  const { applicationCycles } = useContext(ApplicationCycleContext);
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const getApplicationCycles = useCallback(async () => {
    const applicationCycleUrl = `${baseUrl}applicationCycles/`;
    const url = `${applicationCycleUrl}getall`;
    const response = await customFetch<ApplicationCycle[]>(url, {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${authResult.accessToken}`,
      },
    });

    return response;
  }, [authResult, customFetch]);

  const getApplicationCyclesSelectOptions = useCallback(async (): Promise<
    ApplicationCycleSelectOption[]
  > => {
    const applicationCycleUrl = `${baseUrl}applicationCycles/`;
    const url = `${applicationCycleUrl}GetSelectOptions`;
    const response = await customFetch<ApplicationCycleSelectOption[]>(url, {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${authResult.accessToken}`,
      },
    });

    return response;
  }, [authResult, customFetch]);

  const getApplicationCycle = useCallback(
    (appCycleId: number) => {
      return applicationCycles != null
        ? applicationCycles?.find((x: ApplicationCycle) => x.id === appCycleId)
        : null;
    },
    [applicationCycles]
  );

  return { getApplicationCycle, getApplicationCycles, getApplicationCyclesSelectOptions };
}
